import {
  CustomerFindingStatusSchema,
  BulkCustomerFindingStatusSchema,
  type BulkCustomerFindingStatus,
} from '@terra/shared-contracts-findings';
import type { ListCollection } from '@ark-ui/react';
import type { CustomerFindingStatus } from '../../types';
import { formatFindingStatusForDisplay } from '../../utils';
import { createSelectListCollection } from '../../components/select';

export type CustomerFindingStatusOption = {
  label: string;
  value: CustomerFindingStatus;
};

export const CUSTOMER_FINDING_STATUS_OPTIONS: CustomerFindingStatusOption[] =
  CustomerFindingStatusSchema.options.map((status) => ({
    label: formatFindingStatusForDisplay(status),
    value: status,
  }));

export type BulkCustomerFindingStatusOption = {
  label: string;
  value: BulkCustomerFindingStatus;
};

export const BULK_CUSTOMER_FINDING_STATUS_OPTIONS: BulkCustomerFindingStatusOption[] =
  BulkCustomerFindingStatusSchema.options.map((status) => ({
    label: formatFindingStatusForDisplay(status),
    value: status,
  }));

export const getFindingsFiltersSelectListCollection =
  (): ListCollection<CustomerFindingStatusOption> =>
    createSelectListCollection({
      items: CUSTOMER_FINDING_STATUS_OPTIONS,
    });

export const isCustomerFindingStatus = (
  value: string,
): value is CustomerFindingStatus =>
  CustomerFindingStatusSchema.safeParse(value).success;

export const getCustomerFindingStatusFilters = (
  value: string | null,
): CustomerFindingStatus[] =>
  value?.split(',').filter(isCustomerFindingStatus) || [];
